import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { appSelector, profileSelector } from '../../selectors';
import { Menu, Segment, Container, Grid } from 'semantic-ui-react';
import { Switch, Route } from 'react-router-dom';
import UsernameAndPassword from './UsernameAndPassword';
import AccountInformationPage from './AccountInformationPage';
import ChangePasswordPage from './ChangePasswordPage';
import ChangeEmailPage from './ChangeEmailPage';
import ElectronicDelivery from './ElectronicDelivery';
import * as profileActions from '../../actions/profileActions';

class UserProfilePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeItem: 'info',
		};
		this.onMenuItemClick = this.onMenuItemClick.bind(this);
	}

	componentDidMount() {
		const { location, actions, profile } = this.props;

		if (!profile.loaded) {
			actions.getProfile();
		}

		const pathname = location.pathname.replace('/profile', '');
		const activeItem = pathname === '' ? 'info' : pathname.replace('/', '');
		if (activeItem !== this.state.activeItem) {
			this.setState({
				activeItem,
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { location } = this.props;
		const pathname = location.pathname.replace('/profile', '');
		const activeItem = pathname === '' ? 'info' : pathname.replace('/', '');
		if (activeItem !== this.state.activeItem) {
			this.setState({
				activeItem,
			});
		}
	}

	onMenuItemClick(e, { name }) {
		this.setState({
			activeItem: name,
		});
		if (name === 'info') return this.props.actions.push('/profile');
		this.props.actions.push(`/profile/${name}`);
	}

	render() {
		const { activeItem } = this.state;
		const { app, profile } = this.props;

		return (
			<Segment>
				<Container>
					<Grid stackable>
						<Grid.Column tablet={6} computer={4}>
							<Menu secondary vertical>
								<Menu.Item name='info' content='Account Information' active={activeItem === 'info'} onClick={this.onMenuItemClick} />
								<Menu.Item name='security' content='Username and Password' active={activeItem.startsWith('security')} onClick={this.onMenuItemClick} />
								{app.systemToggles.electronicAlertsEnabled || profile.isDeliveryTester ? <Menu.Item name='alerts' content='E-Mail and Text Alerts' active={activeItem.startsWith('alerts')} onClick={this.onMenuItemClick} /> : null}
								{/* <Menu.Item name="ChangePassword" active={activeItem.toLocaleLowerCase() === "changepassword"} onClick={this.onMenuItemClick} /> */}
								{/* <Menu.Item name="ChangeEmail" active={activeItem.toLocaleLowerCase() === "changeemail"} onClick={this.onMenuItemClick} /> */}
							</Menu>
						</Grid.Column>
						<Grid.Column tablet={10} computer={12}>
							<Switch>
								<Route exact path='/profile' component={AccountInformationPage} />
								<Route path='/profile/security/username' component={ChangeEmailPage} />
								<Route path='/profile/security/password' component={ChangePasswordPage} />
								<Route path='/profile/security' component={UsernameAndPassword} />

								<Route path='/profile/alerts' component={ElectronicDelivery} />
							</Switch>
						</Grid.Column>
					</Grid>
				</Container>
			</Segment>
		);
	}
}

UserProfilePage.propTypes = {
	location: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	children: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
	return {
		app: appSelector(state),
		profile: profileSelector(state),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			// ...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch),
			...bindActionCreators(profileActions, dispatch),
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePage);
